<template>
  <div
    class="button-standard-control"
    @click="$emit('click')">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ButtonStandard',
};
</script>

<style lang="scss">
.button-standard-control {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  min-width: 120px;
  padding: 0 20px;
  color: #fff;
  background: linear-gradient(to top, #2cabfe 0, #009aff 100%);
  border-radius: 2px;
  cursor: pointer;
  user-select: none;

  &:hover {
    background: linear-gradient(to bottom, #2cabfe 0, #009aff 100%);
  }
}
</style>
